export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const counterId = Number(config.public.YM_COUNTER_ID);

  if (!Number.isInteger(counterId) || counterId <= 0) return;

  const router = useRouter();

  let previousUrl = window.location.href;
  let hasPendingHit = false;

  router.afterEach(() => {
    hasPendingHit = true;
  });

  nuxtApp.hook('page:finish', () => {
    if (!hasPendingHit) return;
    hasPendingHit = false;

    if (typeof window.ym !== 'function') {
      console.warn('[Metrika] ym is not available, SPA hit skipped');
      return;
    }

    const currentUrl = window.location.href;

    window.ym(counterId, 'hit', currentUrl, {
      title: document.title,
      referer: previousUrl,
    });

    previousUrl = currentUrl;
  });
});
